module.exports = __webpack_public_path__ + "img/artist_header_es_mobile.cde9e0c.png";